import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Select, Card } from 'antd'

@inject((store: any) => {
    const { categoriesStore } = store
    return { categoriesStore }
})
@observer
export default class SelectBox extends Component<any> {
    changeCategory = value => {
        this.props.categoriesStore.updateSelectedByCategory(value)
        this.props.categoryChanged(value)
    }

    render() {
        const { categoryLevels, categoryLevel, styles, title, defaultValue, disabled, value } = this.props
        const { Option } = Select
        return (
            <Card
                key={`box_${categoryLevel}`}
                type="inner"
                size="small"
                title={title}
                style={styles['cardStyle'] ? styles['cardStyle'] : null}
                headStyle={styles['cardHead'] ? styles['cardHead'] : null}
                bodyStyle={styles['cardBody'] ? styles['cardBody'] : null}
            >
                <Select
                    defaultValue={defaultValue}
                    value={value}
                    placeholder="בחר קטגוריה"
                    style={styles ? styles['select'] : { width: '100%' }}
                    onChange={value => this.changeCategory(value)}
                    disabled={disabled}
                >
                    {categoryLevels[categoryLevel].map(cat => {
                        return (
                            <Option key={cat['id']} value={cat['id']}>
                                {`${cat['name']} (${cat['id']})`}
                            </Option>
                        )
                    })}
                </Select>
            </Card>
        )
    }
}
